import { getRoute } from "@utils/route";

export const CAM_DX_PAGE_URL = '/camdx/auth/success';

export const routeCamDxPage = () => getRoute(CAM_DX_PAGE_URL);
